// @ts-nocheck
export const localeCodes =  [
  "cs",
  "de",
  "en",
  "es",
  "fr",
  "it",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru"
]
export const localeLoaders = {
  cs: [],
  de: [],
  en: [],
  es: [],
  fr: [],
  it: [],
  nl: [],
  pl: [],
  pt: [],
  ro: [],
  ru: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/34500cb1" /* webpackChunkName: "config_i18n_46config_46ts_34500cb1" */)
]
export const normalizedLocales = [
  {
    code: "cs",
    language: "cs-CS",
    _hreflang: "cs-CS",
    _sitemap: "cs-CS"
  },
  {
    code: "de",
    language: "de-DE",
    _hreflang: "de-DE",
    _sitemap: "de-DE"
  },
  {
    code: "en",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB"
  },
  {
    code: "es",
    language: "es-ES",
    _hreflang: "es-ES",
    _sitemap: "es-ES"
  },
  {
    code: "fr",
    language: "fr-FR",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  },
  {
    code: "it",
    language: "it-IT",
    _hreflang: "it-IT",
    _sitemap: "it-IT"
  },
  {
    code: "nl",
    language: "nl-NL",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL"
  },
  {
    code: "pl",
    language: "pl-PL",
    _hreflang: "pl-PL",
    _sitemap: "pl-PL"
  },
  {
    code: "pt",
    language: "pt-PT",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT"
  },
  {
    code: "ro",
    language: "ro-RO",
    _hreflang: "ro-RO",
    _sitemap: "ro-RO"
  },
  {
    code: "ru",
    language: "ru-RU",
    _hreflang: "ru-RU",
    _sitemap: "ru-RU"
  }
]
/** client **/

/** client-end **/